import React from "react";
import { Button as AntdButton } from "antd";
import { Props } from "./types";

function Button(props: Props) {
  const {
    children,
    // type = "default",
    // disabled,
    // className = "",
    // isBordered = false,
    // icon,
    onClick,
    ...otherProps
  } = props;

  return (
    <AntdButton onClick={onClick} {...otherProps}>
      {children}
    </AntdButton>
  );
}

export default Button;
